<template>
	<div class="view-body">
		<el-carousel arrow="always" ref="carousel" indicator-position="none" height="450px" class="banner-carousel" :interval="3000" :autoplay="false" :initial-index="initialIndex">
			<el-carousel-item v-for="(item, index) in voucherImg" :key="index">
				<div class="carousel-img">
					<w-image :src="item.newurl.replace('_big', '')"></w-image>
				</div>
			</el-carousel-item>
		</el-carousel>
		<el-button type="primary" size='medium' plain class="img-close-btn" @click="close">关闭</el-button>
	</div>
</template>

<script>
export default {
	name: 'certificateView',
	props: {
		voucherImg: {
			type: Array,
			default: () => []
		},
		initialIndex: {
			type: Number,
			default: 0
		},
		visible: Boolean
	},
	methods: {
		close () {
			this.$emit('update:visible', false)
		}
	}
}
</script>

<style lang="stylus" scoped>
.view-body {
	text-align: center
	height:500px
	.banner-carousel {
		margin:0 auto
		width:600px
		.carousel-img {
			margin:0 auto
			width:450px
			height:450px
			position: relative
			img {
				position: absolute
				max-height: 450px
				max-width: 450px
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
			}
		}
	}
	.img-close-btn {
		margin: auto
		margin-top: 20px
		width: 200px
	}
}
</style>
